export const siteConfig = {
  businessName: "松島オート",
  representative: "松島 朝史",
  phoneDisplay: "090-4470-9811",
  phoneHref: "tel:09044709811",
  address: "〒901-2131 沖縄県浦添市牧港2丁目8-3",
  addressWithoutPostalCode: "沖縄県浦添市牧港2丁目8-3",
  serviceArea: "沖縄本島全域",
  serviceAreaNote: "離島は対象外です。",
  contactNote: "夜間もお問い合わせいただけます",
  closedDay: "日曜定休",
  establishedYear: "2014年開業",
  lineUrl: "",
  googleReviewsUrl: "",
} as const;

export const googleMapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(
  siteConfig.addressWithoutPostalCode,
)}&output=embed&z=16`;

export const quickFacts = [
  {
    id: "towing",
    label: "レッカー代",
    value: "0円",
    priority: "standard",
    icon: "towing",
  },
  {
    id: "deregistration",
    label: "抹消手続き",
    value: "0円",
    priority: "standard",
    icon: "deregistration",
  },
  {
    id: "payment",
    label: "その場で現金払い",
    description: "査定額は、車両の引き取り時にお支払いします",
    priority: "payment",
    icon: "cash",
  },
] as const;

export const callPreparationItems = [
  "メーカー",
  "車種",
  "年式",
  "走行距離",
  "状態",
  "車検期限",
  "車検証の有無",
  "所在市町村",
] as const;

export const vehicleExamples = [
  "エンジンがかからない車",
  "事故や故障で動かない車",
  "車検が切れている車",
] as const;

export const vehicleTypeSummary =
  "軽自動車からトラック・バスまで、自動車全般をご相談いただけます。";
